<app-header mainHeading="Add a new care option"
            [breadcrumbs]="['System settings', 'Care options', 'Add a new care option']"
            [links]="['/settings/general-information', '/settings/care-options', '/settings/care-options/add']" />

<form (ngSubmit)="addCareOption()">
    <main class="add-new-shell">
        <cll-card class="add-new-card">
            <cll-card-header>
                <cll-icon cllCardIcon type="outlined">person</cll-icon>
                <cll-card-title>Basic details</cll-card-title>
            </cll-card-header>

            <div class="add-new-row-container">

                <div>
                    <cll-form-field label="Name" class="w-full">
                        <input cllFormInput [formControl]="careOptionFormGroup.controls.name" type="text">
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="Care type" class="small-input">
                        <cll-select
                            [options]="searchableCareTypeDataSource"
                            [formControl]="careOptionFormGroup.controls.care_type_id"
                        />
                    </cll-form-field>
                </div>
                <div>
                    <cll-form-field label="Description" class="w-full">
                        <textarea cllFormInput type="text"
                                  [formControl]="careOptionFormGroup.controls.description"></textarea>
                    </cll-form-field>
                </div>
                <div class="grid-columns-2">
                    <cll-form-field label="Include price">
                        <select
                            cllFormInput [formControl]="careOptionFormGroup.controls.include_price">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </cll-form-field>
                </div>

            </div>
        </cll-card>

        @if (createCareOptionRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <cll-card>
            <div class="add-new-footer-buttons-container">
                <button cll-button (click)="cancel()">
                    Cancel
                </button>
                <button cll-filled-button colour="secondary" type="submit">
                    <cll-icon cllButtonIcon>check</cll-icon>
                    Create
                </button>
            </div>
        </cll-card>
    </main>
</form>
